import React from 'react';
import { RestrictedComponent } from '../../ui-components/RestrictedComponent';
import { ProductConfigurationPage } from './ProductConfigurationPage';

export const ProductPageWrapper = () =>
  <RestrictedComponent permission='read_product_information' message='NOT PERMITTED'>
    <ProductConfigurationPage />
  </RestrictedComponent>;
